<div class="container">
  <div class="checkbox"></div>
  <div class="description"></div>
</div>
